export const config = {
  apiUrl: import.meta.env.VITE_API_URL || "http://0.0.0.0:3000",
};
